import React from 'react';
import classnames from 'classnames';
import { makeStyles, Box } from '@material-ui/core';
import { selectorStyle } from './styles';
import Column from './Column';
import Row from './Row';

const Selector = ({ children, className }) => {
    const classes = makeStyles(selectorStyle)();

    return <Box className={classnames(classes.container, className)}>{children}</Box>;
};

Selector.Column = Column;
Selector.Row = Row;

export default Selector;
